import React from 'react';

import { classNames } from '@/helpers/classNames';
import { CircularProgress, CircularProgressProps } from '@material-ui/core';

import styles from './Loader.module.scss';

export interface ILoaderProps {
	type?: 'white' | 'smoke' | 'mist' | 'night';
	text?: string;
	fullText?: string;
	size?: CircularProgressProps['size'];
	height?: number;
	className?: string;
}

export const Loader: React.FC<ILoaderProps> = ({
	type,
	text,
	fullText,
	size,
	height,
	className,
}) => {
	const loaderText = fullText || (text && `Loading ${text}`);
	return (
		<div
			className={classNames([
				styles['loader'],
				type === 'white' && styles['loader--white'],
				type === 'smoke' && styles['loader--smoke'],
				type === 'mist' && styles['loader--mist'],
				type === 'night' && styles['loader--night'],
				className,
			])}
			style={height ? { height } : undefined}
		>
			<CircularProgress size={size} />
			{!!loaderText && (
				<div className="font-sm mt-sm">{loaderText} ...</div>
			)}
		</div>
	);
};
